


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { MediumHeavyForm } from '@/models/config'

// Components
import { FormCreateEditMediumHeavy } from '@/components/config'

@Component({
    name: 'ModalCreateEditAfp',
    components: {
        FormCreateEditMediumHeavy
    }
})
export default class ModalCreateEditAfp extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) heavy!: MediumHeavyForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear Nueva Pesada'
        }
        return 'Editar Pesada'
    }
}
